<template>
  <div>
    <TabAtom @tabChanged="tabChanged" />
    <SearchAtom :entities="data" @handleSearch="handleSearch" />
    <EntityList class="entity-list" :tab="activeTabId" :data="searchArray.length > 0 || query.length > 3 ? searchArray : data" />
  </div>
</template>

<script>
import TabAtom from '../atoms/TabAtom.vue';
import SearchAtom from '../atoms/SearchAtom.vue';
import EntityList from '../atoms/EntityListAtom.vue';

export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  components: {
    TabAtom,
    SearchAtom,
    EntityList,
  },
  data() {
    return {
      activeTabId: 1,
      searchArray: [],
      query: '',
    };
  },

  methods: {
    tabChanged(tabId) {
      this.activeTabId = tabId;
    },
    handleSearch(data, query) {
      this.searchArray = data;
      this.query = query;
    },
  },
};
</script>

<style scoped></style>
